import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import styled from 'styled-components'

export const DialogStyled = styled(Dialog)``
export const DialogTitleStyled = styled(DialogTitle)``
export const DialogContentStyled = styled(DialogContent)``
export const DialogActionsStyled = styled(DialogActions)``
